import * as z from "zod/v4";

export const getTripleWhaleOmsIntegration = {
  name: "getTripleWhaleOmsIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    omsEnabled: z.boolean(),
    storeUrl: z.string().nullable(),
  }),
};
